'use client'
import { ToPageButton } from '@/app/ui/parts/default/sp/parts/buttons/toPageButton'
import { serviceType } from '@/lib/service/server'
import { useEffect, useState } from 'react'

export const ArticleBottomButton = ({
  service,
  text,
}: {
  service: serviceType
  text?: string
}) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || window.pageYOffset
      setIsVisible(scrollY > 200)
    }

    // スクロールイベントリスナーを追加
    window.addEventListener('scroll', handleScroll)

    // クリーンアップ関数
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  if (!isVisible) return null

  if (text) {
    return (
      <div
        className="fixed bottom-0 left-0 text-center w-full bg-white"
        style={{ zIndex: 50 }}
      >
        <ToPageButton text={text} href={`/`} />
      </div>
    )
  }

  return (
    <div
      className="fixed bottom-0 left-0 w-full bg-white border-t shadow-lg"
      style={{ zIndex: 30 }}
    >
      <ToPageButton
        text={`${service.prefix}専門通販${service.name}へ進む`}
        href={`/`}
      />
    </div>
  )
}
